'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _IDate = require('../../../common/iObjects/IDate');

var _IDate2 = _interopRequireDefault(_IDate);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var nextYear = null,
        prevYear = null,
        weekDaysHtml = void 0,
        classList = this.compileStyle(_index2.default),
        theme = this.props.theme;

    // year change buttons
    if (this.props.yearChange) {
        prevYear = _react2.default.createElement(_IconButton2.default, {
            icon: theme.yearDecreaseIcon,
            className: classList.controlLeft,
            onClick: function onClick(e) {
                return _this.shift(-1, 'year');
            }
        });
        nextYear = _react2.default.createElement(_IconButton2.default, {
            icon: theme.yearIncreaseIcon,
            className: classList.controlRight,
            onClick: function onClick(e) {
                return _this.shift(1, 'year');
            }
        });
    }

    // week days list
    weekDaysHtml = this.weekDays.map(function (day) {
        return _react2.default.createElement(
            'td',
            { className: classList.weekDay, key: day },
            _l10n2.default.translate(day)
        );
    });

    // calendar dates
    var monthStart = true,
        calendar = [],

    // count of days in month
    daysCount = this.getDaysCount();

    // перебираем все числа месяца

    var _loop = function _loop() {
        var row = [];

        // формирование недели
        _this.weekDays.forEach(function (weekDay, i) {
            var periodOverlay = null,
                dateHtml = null;

            // если месяц начинается не с понедельника, оставляем пробелы
            if (monthStart && _this.firstWeekDay > i) {
                row.push(_react2.default.createElement('td', { key: 'day-' + i }));

                // добрались до существующих дней в неделе
            } else {
                monthStart = false;

                var date = daysCount.shift();
                date = String(date).length < 2 ? '0' + date : date;

                if (date) {
                    var dateObj = new _IDate2.default(_this._currYear + '-' + _this._currMonth + '-' + date),
                        isStartSelected = _this._isStartOfPeriod(dateObj),
                        isEndSelected = _this._isEndOfPeriod(dateObj),
                        dayOfMonth = dateObj.get('date');

                    // маска выбранного периода под числом даты
                    if (_this._isDateInPeriod(dateObj)) {
                        var periodOverlayStyle = classList.period;

                        // старт периода || первый день недели в месяце || первое число месяца
                        if (isStartSelected || dayOfMonth === 1 || i === 0) {
                            periodOverlayStyle = classList.periodStart;
                        }

                        // конец периода || последний день недели || последний день месяца
                        if (isEndSelected || i === 6 || !daysCount.length) {
                            periodOverlayStyle = classList.periodEnd;
                        }

                        if (
                        // первое число выпадает на последний день недели
                        dayOfMonth === 1 && i === 6 ||
                        // последнее число выпадает на первый день недели
                        !daysCount.length && i === 0) {
                            periodOverlayStyle = classList.periodCircle;
                        }

                        // исключения для показа маски периода
                        if (
                        // начало периода - последний день недели
                        isStartSelected && i === 6 ||
                        // конец периода - первый день недели
                        isEndSelected && i === 0 ||
                        // первое число месяца - конец выбранного периода
                        dayOfMonth === 1 && isEndSelected ||
                        // начало и конец периода совпадают
                        _this._isOneDayPeriod() ||
                        // конец периода выпадает на последний день месяца
                        isStartSelected && !daysCount.length) {
                            periodOverlayStyle = classList.periodNoFill;
                        }

                        periodOverlay = _react2.default.createElement('div', { className: periodOverlayStyle });
                    }

                    var dateStyle = classList.date;

                    if (_this._isTodaySelected()) {
                        dateStyle = classList.dateToday;
                    }

                    if (periodOverlay) {
                        dateStyle = classList.datePassive;
                    }

                    if (isStartSelected || isEndSelected) {
                        dateStyle = classList.dateSelected;
                    }

                    if (_this._isForbiddenDate(dateObj)) {
                        dateStyle = classList.dateDisabled;
                    }

                    // дата календаря
                    dateHtml = _react2.default.createElement(
                        'div',
                        { className: dateStyle, onClick: function onClick(e) {
                                return _this.select(dateObj);
                            } },
                        date
                    );
                }

                // календарь
                row.push(_react2.default.createElement(
                    'td',
                    { className: classList.day, key: 'day-' + i },
                    periodOverlay,
                    dateHtml
                ));
            }
        });

        calendar.push(_react2.default.createElement(
            'tr',
            { key: 'row-' + daysCount.length },
            row
        ));
    };

    while (daysCount.length) {
        _loop();
    }

    var controls = null;

    if (this.props.isPeriod) {
        controls = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
                'td',
                { colSpan: '7', className: classList.calendarFooter },
                _react2.default.createElement(
                    _Button2.default,
                    _extends({}, this.props.cancelButton, {
                        className: classList.calendarBtnCancel,
                        onClick: this.cancel
                    }),
                    _l10n2.default.translate('DATEPICKER_CANCEL')
                ),
                _react2.default.createElement(
                    _Button2.default,
                    _extends({}, this.props.submitButton, {
                        onClick: this.submit
                    }),
                    _l10n2.default.translate('DATEPICKER_OK')
                )
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement(
            'div',
            { className: classList.calendar },
            _react2.default.createElement(
                'div',
                { className: classList.calendarHead },
                _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { colSpan: '7', className: classList.control },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    prevYear,
                                    _react2.default.createElement(_IconButton2.default, {
                                        icon: theme.monthDecreaseIcon,
                                        className: classList.controlLeft,
                                        onClick: function onClick(e) {
                                            return _this.shift(-1, 'month');
                                        }
                                    })
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: classList.controlDate },
                                    _l10n2.default.translate(this.state.currentDate.getMonthName()),
                                    '\xA0',
                                    this._currYear
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    nextYear,
                                    _react2.default.createElement(_IconButton2.default, {
                                        icon: theme.monthIncreaseIcon,
                                        className: classList.controlRight,
                                        onClick: function onClick(e) {
                                            return _this.shift(1, 'month');
                                        }
                                    })
                                )
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: classList.calendarBody },
                _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            weekDaysHtml
                        ),
                        calendar
                    ),
                    _react2.default.createElement(
                        'tfoot',
                        null,
                        controls
                    )
                )
            )
        )
    );
}